import { render, staticRenderFns } from "./modifyUserInfo.vue?vue&type=template&id=18094e96&scoped=true"
import script from "./modifyUserInfo.vue?vue&type=script&lang=js"
export * from "./modifyUserInfo.vue?vue&type=script&lang=js"
import style0 from "./modifyUserInfo.vue?vue&type=style&index=0&id=18094e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18094e96",
  null
  
)

export default component.exports